import React, { useState, useEffect } from "react";

function GetCoordsByAddress() {
  const [address, setAddress] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  useEffect(() => {
    // If address is empty, clear coordinates
    if (!address.trim()) {
      setLatitude("");
      setLongitude("");
      return;
    }

    const delayDebounce = setTimeout(() => {
      fetchCoordinates(address);
    }, 800); // debounce: waits for typing to stop

    return () => clearTimeout(delayDebounce);
  }, [address]);

  const fetchCoordinates = async (address) => {
    try {
      const url = `http://localhost:5001/geocode?address=${address}`;
      const response = await fetch(url, {
        headers: {
          "User-Agent": "ReactGeoApp/1.0", // required by Nominatim
        },
      });

      if (!response.ok) throw new Error("Failed to fetch coordinates");

      const data = await response.json();
      if (data.length > 0) {
        setLatitude(data[0].lat);
        setLongitude(data[0].lon);
        
      } else {
        setLatitude("");
        setLongitude("");
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      setLatitude("");
      setLongitude("");
    }
  };


  

  return (
    <div style={{ padding: "20px", fontFamily: "Arial" }}>
      <h3>Get Coordinates by Address</h3>
      <input
        type="text"
        placeholder="Enter address (e.g. Miyapur, Hyderabad)"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
        style={{
          width: "300px",
          padding: "8px",
          marginBottom: "10px",
          border: "1px solid #ccc",
          borderRadius: "5px",
        }}
      />
      <div>
        <p><b>Latitude:</b> {latitude}</p>
        <p><b>Longitude:</b> {longitude}</p>
      </div>
    </div>
  );
}



export default GetCoordsByAddress;
